import { useCanEditEntityGroups } from '~/hooks/useCanEditEntityGroups';
import { managedEntities } from '~/redux/api/managed-entities';

export const useDocumentGroups = (
  resourceId?: string | number,
  resourceType: 'document' | 'ticket' | 'ticket_v2' = 'document',
) => {
  const { canView } = useCanEditEntityGroups();
  return managedEntities.endpoints.listNodes.useQuery(
    {
      filter: { resource_type: resourceType, resource_id: String(resourceId) },
      include: ['groups'],
    },
    { skip: !resourceId || !canView },
  );
};
